import currencies from "./currencies";
import {
  parseStringToMoneyValue,
  extractDecimalAmount,
  type MoneyValue,
  type MoneyInputValue,
} from "./parsing-utilities";

// Replace lodash/has with native implementation
const has = (obj: Record<string, unknown>, key: string): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

// Static method implementations - preserve exact logic from UI Kit
export function getMoneyGroupAttribute(
  attr?: string,
  inputType?: string
): string | undefined {
  return attr && inputType ? `${attr}.${inputType}` : undefined;
}

export const transformFormInputToMoneyValue = (
  value: MoneyInputValue,
  locale: string
) =>
  parseStringToMoneyValue(
    typeof value.amount === "string" ? value.amount.trim() : "",
    locale,
    value.currencyCode
  );

export const formatMoneyValueForDisplay = (
  moneyValue: MoneyValue,
  locale: string
): MoneyInputValue => {
  if (!moneyValue) return { currencyCode: "", amount: "" };

  console.warn(
    typeof locale === "string",
    "MoneyInput.parseMoneyValue: A locale must be passed as the second argument"
  );

  console.warn(
    typeof moneyValue === "object",
    "MoneyInput.parseMoneyValue: Value must be passed as an object or be undefined"
  );

  console.warn(
    typeof moneyValue.currencyCode === "string",
    'MoneyInput.parseMoneyValue: Value must contain "currencyCode"'
  );

  if (typeof moneyValue.currencyCode !== "string") {
    throw new Error(
      'MoneyInput.parseMoneyValue: Value must contain "currencyCode"'
    );
  }

  console.warn(
    has(currencies, moneyValue.currencyCode),
    "MoneyInput.parseMoneyValue: Value must use known currency code"
  );

  if (!has(currencies, moneyValue.currencyCode)) {
    throw new Error(
      "MoneyInput.parseMoneyValue: Value must use known currency code"
    );
  }

  console.warn(
    // highPrecision or centPrecision values must be set
    typeof moneyValue.centAmount === "number" ||
      (typeof moneyValue.preciseAmount === "number" &&
        typeof moneyValue.fractionDigits === "number"),
    'MoneyInput.parseMoneyValue: Value must contain "amount"'
  );

  // Direct formatting without circular conversion
  const amountAsNumber = extractDecimalAmount(moneyValue);
  const fractionDigits = moneyValue.preciseAmount
    ? moneyValue.fractionDigits
    : currencies[moneyValue.currencyCode].fractionDigits;

  const amount = isNaN(amountAsNumber)
    ? ""
    : amountAsNumber.toLocaleString(locale, {
        minimumFractionDigits: fractionDigits,
      });

  return { amount, currencyCode: moneyValue.currencyCode };
};

export const isEmpty = (formValue: MoneyInputValue) => {
  return (
    !formValue ||
    formValue?.amount?.trim() === "" ||
    formValue?.currencyCode?.trim() === ""
  );
};

export const isHighPrecision = (
  formValue: MoneyInputValue,
  locale: string
): boolean => {
  if (isEmpty(formValue)) {
    return false;
  }
  const moneyValue = transformFormInputToMoneyValue(formValue, locale);
  return moneyValue?.type === "highPrecision";
};
